import React from 'react';

/**
 * The inoRain wordmark.
 *
 * The supplied asset hard-coded #0F87B2 on every path and sat on an opaque
 * white rectangle. Both are removed here: the paths inherit `currentColor` so
 * the mark can sit on a light or dark surface by setting `color`, and the
 * background is transparent so it composites over anything.
 */
const Logo = ({ height = 30, className = '', title = 'inoRain' }) => (
    <svg
        viewBox="0 0 91 42"
        height={height}
        width={(91 / 42) * height}
        className={`ino-logo ${className}`}
        role="img"
        aria-label={title}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{title}</title>
        {/* upper and lower swooshes */}
        <path fillRule="evenodd" clipRule="evenodd" d="M.25 9.2H27.3c3.04 0 7.91.43 10.7-.54a10 10 0 0 0 6.1-5.62h-3.95c-1.39 2.3-4.1 2.93-7.54 2.91h-21.5C5.85 5.95 1.2 4.82.24 9.2" />
        <path fillRule="evenodd" clipRule="evenodd" d="M91 32.16H63.94c-3.04 0-7.92-.43-10.7.54a10 10 0 0 0-6.1 5.62h3.95c1.39-2.3 4.09-2.93 7.54-2.9h21.5c5.27 0 9.9 1.13 10.87-3.26" />
        {/* i n o R a i n */}
        <path fillRule="evenodd" clipRule="evenodd" d="M.2 17.7v4.39c0 3.24-.4 5.74 2.83 6l.04-7.25A3.1 3.1 0 0 0 .2 17.7m.42-1.53a3.1 3.1 0 0 0 2.57 1.77v-1.77q-.03-.6-.28-1.18a3.1 3.1 0 0 0-2.58-1.77V15q.03.62.29 1.18" />
        <path fillRule="evenodd" clipRule="evenodd" d="M8.38 22.14v-1.92a4.13 4.13 0 1 1 8.24 0v1.92c0 3.23-.4 5.71 2.83 5.97l.03-7.2-.01-.29v-.4a7 7 0 0 0-6.97-7.02 7 7 0 0 0-6.96 7.42l-.01.28.03 7.2c3.22-.25 2.82-2.73 2.82-5.96" />
        <path fillRule="evenodd" clipRule="evenodd" d="M36.7 20.65c0-4.14-3.34-7.5-7.45-7.5a7.47 7.47 0 0 0-7.45 7.5c0 4.14 3.34 7.5 7.45 7.5a7.47 7.47 0 0 0 7.45-7.5m-2.83 0a4.63 4.63 0 1 0-7.9 3.28 4.64 4.64 0 0 0 6.56 0 4.6 4.6 0 0 0 1.34-3.28" />
        <path fillRule="evenodd" clipRule="evenodd" d="M51.27 15.64q-.31-.44-.69-.81a7 7 0 0 0-4.5-1.65c-1.8 0-3.54.68-4.84 1.91a3 3 0 0 0-2.2-1.13v4.37c0 .85-.03 1.65 0 2.37l-.01.2.03 7.22c3.25-.25 2.85-2.74 2.85-5.98v-2.03a4.15 4.15 0 0 1 3.28-3.95l.14-.03q.14-.02.24-.06a4 4 0 0 1 2.1.12q.34.21.66.48l.1.1a2.76 2.76 0 0 0 3.54.1q-.29-.64-.7-1.23" />
        <path fillRule="evenodd" clipRule="evenodd" d="M57.36 20.65a4.4 4.4 0 1 1 8.78-.03v1.16c0 3.44-.42 6.1 3 6.36l.04-6.98.02-.51c0-4.14-3.34-7.5-7.45-7.5a7.47 7.47 0 0 0-6.34 11.42 7.5 7.5 0 0 0 3 2.77 9 9 0 0 0 2.15.53c.8.08 1.75.01 2.52-.29s1.36-.85 1.62-1.52c.26-.68.2-1.48.15-2.3a4.35 4.35 0 0 1-6.21 0 4.4 4.4 0 0 1-1.28-3.12" />
        <path fillRule="evenodd" clipRule="evenodd" d="M71.54 17.7v4.39c0 3.24-.4 5.74 2.84 6l.03-7.25a3.1 3.1 0 0 0-2.87-3.15m.42-1.53a3.1 3.1 0 0 0 2.58 1.77v-1.77q-.03-.6-.29-1.18a3.1 3.1 0 0 0-2.57-1.77V15q.03.62.28 1.18" />
        <path fillRule="evenodd" clipRule="evenodd" d="M79.72 22.14v-1.92a4.13 4.13 0 1 1 8.25 0v1.92c0 3.23-.4 5.71 2.82 5.97l.04-7.2-.01-.29v-.4a7 7 0 0 0-6.97-7.02 7 7 0 0 0-6.96 7.42l-.02.28.04 7.2c3.22-.25 2.82-2.73 2.82-5.96" />
    </svg>
);

export default Logo;
